import React, { useState } from "react";

import { Button } from "@mui/material";

import { makeStyles } from "@mui/styles";
import Container from "@mui/material/Container";
import DB from "_DatabaseFunctions/directConnect";

interface GameInfo {
  id: string;
  [key: string]: any;
}

interface AddToWaitlistFieldProps {
  gameInfo: GameInfo;
  setModalDets?: (dets: any) => void;
}

const useStyles = makeStyles(() => ({
  formContainer: {
    width: "70%",
  },
}));

const AddToWaitlistField: React.FC<AddToWaitlistFieldProps> = ({
  gameInfo,
}) => {
  const gameId = gameInfo.id;
  const classes = useStyles();

  const [playerName, setPlayerName] = useState("");
  const [msg, setMsg] = useState("");

  const addPlayerManually = async (event: React.FormEvent) => {
    event.preventDefault();
    const res = await DB.addPlayerToWaitManually(gameId, playerName);
    setMsg(res.msg);
    setPlayerName("");
  };

  return (
    <Container className={classes.formContainer}>
      <form
        onSubmit={async (event) => {
          await addPlayerManually(event);
        }}
        className="form-styles"
      >
        <input
          type="text"
          name="name"
          value={playerName}
          onChange={(event) => setPlayerName(event.target.value)}
          className="form-text-input"
          placeholder="Player Name"
        />
        <Button
          variant="success"
          onClick={async (event) => {
            await addPlayerManually(event);
          }}
        >
          Add Player To Waitlist
        </Button>
      </form>
      <br />
      <div style={{ color: "red" }}>
        <h5>{msg}</h5>
      </div>
    </Container>
  );
};

export default AddToWaitlistField;
